const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const DISPLAY_DATE_PATTERN = /^\d{2}\/\d{2}\/\d{4}$/;

export const toIsoDate = (value: string): string => {
  const normalizedValue = value.trim();

  if (!normalizedValue) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}T/.test(normalizedValue)) {
    return normalizedValue.slice(0, 10);
  }

  if (ISO_DATE_PATTERN.test(normalizedValue)) {
    return normalizedValue;
  }

  if (DISPLAY_DATE_PATTERN.test(normalizedValue)) {
    const [day, month, year] = normalizedValue.split("/");
    return `${year}-${month}-${day}`;
  }

  return normalizedValue;
};

export const parseIsoDate = (value: string): Date | null => {
  const isoDate = toIsoDate(value);

  if (!ISO_DATE_PATTERN.test(isoDate)) {
    return null;
  }

  const [year, month, day] = isoDate.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const formatDisplayDate = (value: string): string => {
  const isoDate = toIsoDate(value);

  if (!ISO_DATE_PATTERN.test(isoDate)) {
    return value;
  }

  const [year, month, day] = isoDate.split("-");
  return `${day}/${month}/${year}`;
};
